import { Integrations } from '@sentry/apm';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://fcbde8d484264489820ce6e920240dc0@o438449.ingest.sentry.io/5403178',
  environment: process.env.NODE_ENV,
  release: process.env.REACT_APP_BUILD_VERSION,
  integrations: [new Integrations.Tracing()],
  tracesSampleRate: 0.1,
});
